"use client";

import React, { useContext, useState } from "react";
import { DataContext } from "../Context/DataContext";
import styles from "./Cars.module.css";

import { FaUserFriends, FaGasPump, FaTachometerAlt } from "react-icons/fa";
import { BsFillGearFill } from "react-icons/bs";

import BookingForm from "../BookingForm/BookingForm"; // ✅ استدعاء الفورم
import { FiZap } from "react-icons/fi";

const Cars = () => {
  const { cars, loading } = useContext(DataContext);
  const [selectedCar, setSelectedCar] = useState(null); // ✅ علشان نحدد العربية المختارة
  const [isBookingOpen, setIsBookingOpen] = useState(false); // ✅ فتح/قفل المودال

  const handleCarSelect = (car) => {
    setSelectedCar(car);
    setIsBookingOpen(true);
  };

  if (loading) {
    return <p style={{ color: "#fff", textAlign: "center" }}>جارٍ تحميل السيارات...</p>;
  }

  return (
    <div className={styles.dataContainer}>
          <div className={styles.luxuryHeader}>
                <div className={styles.premiumBadge}>
                  <FiZap className={styles.iconFlash} />
                  <span>Premium Fleet Selection</span>
                </div>
                <h1 className={styles.mainTitle}>Luxury Car Collection</h1>
                <p className={styles.description}>
                  Discover premium vehicles with exceptional performance and comfort for your next
                  <br />
                  journey
                </p>
              </div>

      <div className={styles.carsGrid}>
        {cars.map((car) => (
          <div key={car.id} className={styles.carCard}>
            <div className={styles.carImage}>
              <img
                src={car.image}
                alt={car.name}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/luxury-car-dark-theme.png";
                }}
              />
              <div className={styles.priceTag}>₹{car.price}/day</div>
            </div>

            <div className={styles.carInfo}>
              <h3 className={styles.carName}>{car.name}</h3>
              <div className={styles.carCategory}>Luxury Car</div>

              <div className={styles.carFeatures}>
                <div className={styles.feature}>
                  <div className={styles.iconCircle}>
                    <FaUserFriends className={styles.icon} />
                  </div>
                  <span className={styles.featureValue}>{car.seats}</span>
                  <span className={styles.featureLabel}>Seats</span>
                </div>

                <div className={styles.feature}>
                  <div className={styles.iconCircle}>
                    <FaGasPump className={styles.icon} />
                  </div>
                  <span className={styles.featureValue}>{car.fuelType}</span>
                  <span className={styles.featureLabel}>Fuel</span>
                </div>

                <div className={styles.feature}>
                  <div className={styles.iconCircle}>
                    <FaTachometerAlt className={styles.icon} />
                  </div>
                  <span className={styles.featureValue}>{car.mileage}</span>
                  <span className={styles.featureLabel}>Mileage</span>
                </div>

                <div className={styles.feature}>
                  <div className={styles.iconCircle}>
                    <BsFillGearFill className={styles.icon} />
                  </div>
                  <span className={styles.featureValue}>{car.transmission}</span>
                  <span className={styles.featureLabel}>Trans</span>
                </div>
              </div>

              <button
                className={styles.bookBtn}
                onClick={() => handleCarSelect(car)}
              >
                Book Now →
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* ✅ مودال الحجز */}
      {isBookingOpen && selectedCar && (
        <BookingForm
          serviceTitle={selectedCar.name}
          servicePrice={selectedCar.price}
          onClose={() => setIsBookingOpen(false)}
        />
      )}
    </div>
  );
};

export default Cars;
